import CircularProgress from '@mui/material/CircularProgress';
import '../../styles/buttons/mainSquareButton.scss';

type props = {
  onClick?: (event: React.MouseEvent) => void;
  icon?: any;
  image?: any;
  isImageHeightFixed?: boolean;
  /** Prevents image and text from overlapping (e.g. GA connection button with logo + status text) */
  contentLayout?: 'default' | 'imageTextSeparate';
  value: string;
  classes?: string;
  loading?: boolean;
  disabled?: boolean;
  normal?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
  buttonType?:
    | 'danger'
    | 'warning'
    | 'success'
    | 'light'
    | 'filter'
    | 'delete'
    | 'white'
    | 'purple'
    | 'darkBlue';
  form?: string;
  message?: string;
  style?: React.CSSProperties;
};

const MainSquareButton: React.FC<props> = ({
  onClick,
  icon,
  image,
  isImageHeightFixed,
  contentLayout = 'default',
  value,
  type,
  disabled,
  classes = '',
  normal,
  buttonType,
  form,
  message,
  loading,
  style,
}) => {
  let isNormalButton;
  if (normal) isNormalButton = 'true';
  else isNormalButton = 'false';

  // Get spinner color based on button type and classes
  const getSpinnerColor = () => {
    // Check for cancel class first
    if (classes.includes('subscriptionSettingsCurrentPlan__actions--cancel')) {
      return '#dc2626';
    }

    switch (buttonType) {
      case 'white':
        return 'var(--main-text-color)';
      case 'purple':
        return '#fff';
      case 'delete':
        return '#ffffff';
      case 'danger':
        return '$web-color-danger';
      default:
        return 'var(--main-btn-text-color)';
    }
  };

  return (
    <button
      onClick={onClick}
      style={style}
      type={type}
      disabled={disabled || loading}
      className={'mainSquareButton' + (' ' + classes)}
      data-main-square-button-normal={isNormalButton}
      data-main-square-button-type={buttonType}
      data-main-square-button-loading={loading ? 'true' : 'false'}
      form={form}
      title={disabled ? message : ''}
    >
      <div className='mainSquareButton__loading'>
        <div className='mainSquareButton__loading--spinner'>
          <CircularProgress
            size={'1.5rem'}
            style={{
              color: getSpinnerColor(),
            }}
          />
        </div>
      </div>

      <div
        data-is-image-height-fixed={isImageHeightFixed ? true : false}
        data-content-layout={contentLayout}
        className='mainSquareButton__content'
      >
        {icon}
        {!icon && image && <img src={image} alt={value} />}
        <p>{value}</p>
      </div>
    </button>
  );
};

export default MainSquareButton;
